import { Alert, Box, LinearProgress, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import { OwnedBoardSummary } from '../../services/teamsSetupApi';

interface ExistingBoardsListProps {
  isLoadingBoards: boolean;
  boardsError: string | null;
  ownedBoards: OwnedBoardSummary[];
  selectedExistingBoardId: string;
  onSelectBoard: (boardId: string) => void;
}

const ExistingBoardsList = ({
  isLoadingBoards,
  boardsError,
  ownedBoards,
  selectedExistingBoardId,
  onSelectBoard,
}: ExistingBoardsListProps) => {
  return (
    <Box>
      {isLoadingBoards ? <LinearProgress sx={{ mb: 2 }} /> : null}
      {boardsError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {boardsError}
        </Alert>
      ) : null}
      {!isLoadingBoards && !boardsError && ownedBoards.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          You do not have any existing boards yet. Create a new board instead.
        </Typography>
      ) : null}
      {!isLoadingBoards && !boardsError && ownedBoards.length > 0 ? (
        <List dense disablePadding>
          {ownedBoards.map((board) => (
            <ListItemButton
              key={board.id}
              selected={board.id === selectedExistingBoardId}
              onClick={() => onSelectBoard(board.id)}
            >
              <ListItemText
                primary={board.title}
                secondary={
                  board.created ? `Created ${new Date(board.created).toLocaleDateString()}` : undefined
                }
              />
            </ListItemButton>
          ))}
        </List>
      ) : null}
    </Box>
  );
};

export default ExistingBoardsList;
